import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";
import { format } from "date-fns";

const addRequirement = (requirement, token) => {
  const config = configurationForToken(token);
  const providerId = +requirement.providerId 
  return apiClient.post("/admin/requirement/create", {
    description: requirement.description,
    leaseId: requirement.leaseId,
    title: requirement.title,
    type: requirement.type,
    hasPriority: !!requirement.hasPriority,
    providerId: providerId ? providerId : null,
    actionDate: format(new Date(requirement.actionDate), "yyyy-MM-dd")
  }, config);
};

const updateRequirement = (requirement, token) => {
  const config = configurationForToken(token);
  const providerId = +requirement.providerId 
  return apiClient.put("/admin/requirement/edit", {
    id: requirement.id,
    description: requirement.description,
    leaseId: requirement.leaseId,
    state: requirement.state,
    title: requirement.title,
    type: requirement.type,
    hasPriority: !!requirement.hasPriority,
    providerId: providerId ? providerId : null,
    actionDate: format(new Date(requirement.actionDate), "yyyy-MM-dd")
  }, config);
};

const deleteRequirement = (requirementId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete("/admin/requirement/delete", {
    data: {id: requirementId},
    ...config,
  });
};

const allRequirements = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/requirement/all", config);
};

export default {
  addRequirement,
  updateRequirement,
  deleteRequirement,
  allRequirements,
};



// WEBPACK FOOTER //
// ./src/Services/RequirementService.js